module.exports = __webpack_public_path__ + "72f3a8f52db24d06608f60a63f61475e.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/demo/treemap.png
// module id = 2405
// module chunks = 0